import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { replace, useParams } from 'react-router-dom';
import { tiposArquivos, tiposArquivosLabel } from '../../Enum/tipoArquivos';
import { tiposConteudoLabel } from '../../Enum/tipoConteudos';

function CadastroConteudoArquivos() {
    const { conteudoID: conteudoIDParam } = useParams();

    const conteudoIDFromParams = conteudoIDParam ? parseInt(conteudoIDParam, 10) : null;

    const [conteudoID, setConteudoID] = useState(conteudoIDFromParams || null);
    const [conteudo, setConteudo] = useState({
        tipoConteudo: '',
        titulo: '',
        observacao: '',
    });

    const [tipoArquivo, setTipoArquivo] = useState('');
    const [arquivos, setArquivos] = useState([]);
    const [arquivosInfo, setArquivosInfo] = useState([]);

    const [videoURL, setVideoURL] = useState({ nomeArquivo: '', url: '' });
    const [linkURL, setLinkURL] = useState({ nomeArquivo: '', url: '' });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (conteudoIDFromParams) {
            // Buscar dados do conteúdo existente
            const fetchConteudo = async () => {
                try {
                    const res = await api.get(`/conteudos/${conteudoIDFromParams}`);
                    setConteudoID(res.data.conteudoID);
                    setConteudo({
                        tipoConteudo: res.data.tipoConteudo,
                        titulo: res.data.titulo,
                        observacao: res.data.observacao || '',
                    });
                } catch (err) {
                    console.error('Erro ao buscar conteúdo', err);
                }
            };
            fetchConteudo();
        } else {
            // Resetar tudo se não tiver conteudoID na rota
            setConteudoID(null);
            setConteudo({
                tipoConteudo: '',
                titulo: '',
                observacao: '',
            });
            setTipoArquivo('');
            setArquivos([]);
            setArquivosInfo([]);
            setVideoURL({ nomeArquivo: '', url: '' });
            setLinkURL({ nomeArquivo: '', url: '' });
        }
    }, [conteudoIDFromParams]);


    // Criar conteúdo
    const criarConteudo = async () => {
        if (!conteudo.tipoConteudo || !conteudo.titulo) {
            alert('Tipo e título são obrigatórios');
            return;
        }

        try {
            setLoading(true);
            const resp = await api.post('/conteudos', conteudo);
            setConteudoID(resp.data.conteudoID);
            alert('Conteúdo criado com sucesso');
        } catch (err) {
            alert('Erro ao criar conteúdo');
        } finally {
            setLoading(false);
        }
    };

    // Upload múltiplo arquivos
    const enviarArquivos = async () => {
        if (!conteudoID) {
            alert('Crie o conteúdo primeiro!');
            return;
        }
        if (!tipoArquivo) {
            alert('Selecione o tipo de arquivo');
            return;
        }
        if (arquivos.length === 0) {
            alert('Selecione ao menos um arquivo');
            return;
        }

        const formData = new FormData();
        arquivos.forEach((arquivo) => {
            formData.append('arquivos', arquivo);
        });
        formData.append('conteudoID', conteudoID);
        formData.append('tipo', tipoArquivo);

        if (arquivosInfo.length > 0) {
            formData.append('arquivosInfo', JSON.stringify(arquivosInfo));
        }

        try {
            setLoading(true);
            await api.post(`/arquivos/upload/${tipoArquivo}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            alert('Arquivos enviados com sucesso');
            setArquivos([]);
            setArquivosInfo([]);
            document.querySelector('input[type="file"]').value = null;
        } catch (err) {
            console.error('Erro ao enviar arquivos', err);
            alert('Erro ao enviar arquivos');
        } finally {
            setLoading(false);
        }
    };

    // Upload vídeo via URL
    const enviarVideoURL = async () => {
        if (!conteudoID) {
            alert('Crie o conteúdo primeiro!');
            return;
        }
        if (!videoURL.nomeArquivo || !videoURL.url) {
            alert('Preencha nome e URL do vídeo');
            return;
        }

        try {
            setLoading(true);
            await api.post('/arquivos/video-url', {
                conteudoID,
                nomeArquivo: videoURL.nomeArquivo,
                url: videoURL.url,
            });
            alert('URL do vídeo salva com sucesso');
            setVideoURL({ nomeArquivo: '', url: '' });
        } catch (err) {
            alert('Erro ao salvar URL do vídeo');
        } finally {
            setLoading(false);
        }
    };

    // Upload link via URL
    const enviarLinkURL = async () => {
        if (!conteudoID) {
            alert('Crie o conteúdo primeiro!');
            return;
        }
        if (!linkURL.nomeArquivo || !linkURL.url) {
            alert('Preencha nome e URL do link');
            return;
        }

        try {
            setLoading(true);
            await api.post('/arquivos/link-url', {
                conteudoID,
                nomeArquivo: linkURL.nomeArquivo,
                url: linkURL.url,
            });
            alert('URL do link salva com sucesso');
            setLinkURL({ nomeArquivo: '', url: '' });
        } catch (err) {
            alert('Erro ao salvar URL do link');
        } finally {
            setLoading(false);
        }
    };

    // Atualiza arquivos e nomes personalizados ao selecionar novos
    const handleSelecionarArquivos = (e) => {
        const files = Array.from(e.target.files);
        setArquivos(files);

        const novasInfos = files.map((file, i) => ({
            nomeArquivo: arquivosInfo[i]?.nomeArquivo || file.name,
        }));
        setArquivosInfo(novasInfos);
    };

    return (
        <div className="container mt-4">
            <h2>Cadastro de Conteúdo</h2>

            {/* Form Conteúdo */}
            <div className="mb-3">
                <label>Tipo de Conteúdo</label>
                <select
                    className="form-select"
                    value={conteudo.tipoConteudo}
                    disabled={conteudoID}
                    onChange={(e) =>
                        setConteudo({ ...conteudo, tipoConteudo: Number(e.target.value) })
                    }
                    style={{ fontWeight: 'bold', color: '#202135' }}
                >
                    <option value="">Selecione</option>
                    {Object.entries(tiposConteudoLabel).map(([id, nome]) => (
                        <option key={id} value={id}>{nome}</option>
                    ))}
                </select>
            </div>

            <div className="mb-3">
                <label>Título</label>
                <input
                    className="form-control"
                    value={conteudo.titulo}
                    maxLength={255}
                    disabled={conteudoID}
                    onChange={(e) =>
                        setConteudo({ ...conteudo, titulo: e.target.value.trim() })
                    }
                    style={{ paddingTop: 10, paddingBottom: 10, fontSize: 14 }}
                />
            </div>

            <div className="mb-3">
                <label>Observação</label>
                <textarea
                    className="form-control"
                    disabled={conteudoID}
                    value={conteudo.observacao}
                    maxLength={500}
                    onChange={(e) =>
                        setConteudo({ ...conteudo, observacao: e.target.value.trim() })
                    }
                    style={{ paddingTop: 10, paddingBottom: 10, fontSize: 14 }}
                />
            </div>

            <button
                className="btn btn-primary"
                onClick={criarConteudo}
                disabled={loading || conteudoID !== null}
            >
                Criar Conteúdo
            </button>

            {conteudoID && (
                <>
                    <hr />
                    <h3>Upload de Arquivos para Conteúdo <span style={{ fontSize: 15 }}><i>({conteudo.titulo})</i></span></h3>

                    {/* Tipo de arquivo */}
                    <div className="mb-3">
                        <label>Tipo de Arquivo</label>
                        <select
                            className="form-select"
                            value={tipoArquivo}
                            onChange={(e) => setTipoArquivo(e.target.value)}
                            style={{ fontWeight: 'bold', color: '#202135' }}
                        >
                            <option value="">Selecione</option>
                            {Object.entries(tiposArquivosLabel).map(([id, nome]) => (
                                <option key={id} value={id}>{nome}</option>
                            ))}
                        </select>
                    </div>

                    {/* Upload múltiplo */}
                    {Number(tipoArquivo) !== tiposArquivos.LINK_URL && Number(tipoArquivo) !== tiposArquivos.VIDEO_URL && (
                        <>
                            <div className="mb-3">
                                <label>Selecione os arquivos</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    multiple
                                    onChange={handleSelecionarArquivos}
                                    disabled={!tipoArquivo}
                                    accept=".pdf,.jpg,.jpeg,.png"
                                />
                                {arquivos.map((file, index) => (
                                    <div key={index} className="mt-2">
                                        <label>Nome personalizado para: <span style={{ fontSize: 13 }}><i>{file.name}</i></span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={arquivosInfo[index]?.nomeArquivo || ''}
                                            maxLength={255}
                                            onChange={(e) => {
                                                const novasInfos = [...arquivosInfo];
                                                novasInfos[index] = { nomeArquivo: e.target.value };
                                                setArquivosInfo(novasInfos);
                                            }}
                                            style={{ paddingTop: 5, paddingBottom: 5, fontSize: 13 }}
                                        />
                                    </div>
                                ))}
                            </div>
                            <button
                                className="btn btn-success"
                                onClick={enviarArquivos}
                                disabled={loading || !tipoArquivo || arquivos.length === 0}
                            >
                                Enviar Arquivos
                            </button>
                        </>
                    )}
                    {/* END Upload múltiplo */}

                    <hr />


                    {/* Vídeo URL */}
                    {Number(tipoArquivo) === tiposArquivos.VIDEO_URL && (
                        <>
                            <h3>Enviar Vídeo via URL</h3>
                            <div className="mb-3">
                                <label>Nome do Vídeo</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={videoURL.nomeArquivo}
                                    maxLength={255}
                                    onChange={(e) =>
                                        setVideoURL({ ...videoURL, nomeArquivo: e.target.value })
                                    }
                                    style={{ paddingTop: 5, paddingBottom: 5, fontSize: 13 }}
                                />
                            </div>
                            <div className="mb-3">
                                <label>URL do Vídeo</label>
                                <input
                                    type="url"
                                    className="form-control"
                                    value={videoURL.url}
                                    onChange={(e) =>
                                        setVideoURL({ ...videoURL, url: e.target.value })
                                    }
                                    style={{ paddingTop: 5, paddingBottom: 5, fontSize: 13 }}
                                />
                            </div>
                            <button
                                className="btn btn-info"
                                onClick={enviarVideoURL}
                                disabled={loading}
                            >
                                Enviar Vídeo
                            </button>
                        </>
                    )}
                    {/* END Vídeo URL */}

                    {/* LINK URL */}
                    {Number(tipoArquivo) === tiposArquivos.LINK_URL && (
                        <>
                            <h3>Enviar Link via URL</h3>
                            <div className="mb-3">
                                <label>Descrição do Link</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={linkURL.nomeArquivo}
                                    maxLength={255}
                                    onChange={(e) =>
                                        setLinkURL({ ...linkURL, nomeArquivo: e.target.value })
                                    }
                                    style={{ paddingTop: 5, paddingBottom: 5, fontSize: 13 }}
                                />
                            </div>
                            <div className="mb-3">
                                <label>URL do Link</label>
                                <input
                                    type="url"
                                    className="form-control"
                                    value={linkURL.url}
                                    onChange={(e) =>
                                        setLinkURL({ ...linkURL, url: e.target.value })
                                    }
                                    style={{ paddingTop: 5, paddingBottom: 5, fontSize: 13 }}
                                />
                            </div>
                            <button
                                className="btn btn-info"
                                onClick={enviarLinkURL}
                                disabled={loading}
                            >
                                Gerar Link
                            </button>
                        </>
                    )}
                    {/* END LINK URL */}
                </>
            )}
        </div>
    );
}

export default CadastroConteudoArquivos;
